import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { FounderSection } from '../components/FounderSection';
import { PriceCalculator } from '../components/PriceCalculator';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Toaster } from '../components/ui/sonner';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <ServicesSection />
      <WhyChooseUsSection />
      <HowItWorksSection />
      <FounderSection />
      <PriceCalculator />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-right" />
    </div>
  );
};

export default LandingPage;
